import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  ClientSharePointWebLinkAttachmentDestroyAction,
  ClientSharePointWebLinkAttachmentEmbedLoadFulfilledAction,
  ClientSharePointWebLinkAttachmentEmbedLoadPendingAction,
  ClientSharePointWebLinkAttachmentEmbedLoadRejectedAction,
} from '../../domains/resolveClientSharePointWebLink/actions.types';

import { ClientSharePointWebLinkEmbeds } from './types';

export type ClientSharePointWebLinkAction =
  | ClientSharePointWebLinkAttachmentEmbedLoadFulfilledAction
  | ClientSharePointWebLinkAttachmentEmbedLoadPendingAction
  | ClientSharePointWebLinkAttachmentEmbedLoadRejectedAction
  | ClientSharePointWebLinkAttachmentDestroyAction;

const initialState: ClientSharePointWebLinkEmbeds = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const destroyClientSharePointWebLink = (state: ClientSharePointWebLinkEmbeds, webLinkId: string) =>
  remove(state, [webLinkId]);

const reducer: Reducer<ClientSharePointWebLinkEmbeds, ClientSharePointWebLinkAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SHAREPOINT_WEBLINK_EMBED.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.clientSharePointWebLink.id], action.payload.error);
    case 'SHAREPOINT_WEBLINK_EMBED.LOAD_PENDING':
      return moveToPending(state, [action.payload.clientSharePointWebLink.id]);
    case 'SHAREPOINT_WEBLINK_EMBED.LOAD_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.clientSharePointWebLinkEmbed.id]: action.payload.clientSharePointWebLinkEmbed,
      });
    case 'SHAREPOINT_WEBLINK.DESTROY':
      return destroyClientSharePointWebLink(state, action.payload.clientSharePointWebLinkId);
    default:
      return state;
  }
};

export default reducer;
